import React from 'react';
import { Fab, GlobalActions } from '@michelin/acid-components';
import {
  Add, Cancel, Edit, Save, Timelapse,
} from '@material-ui/icons';
import { useTranslation } from '@michelin/central-provider';

interface ActionButtonsProps {
  updatePermission?: boolean;
  action: 'view' | 'edit';
  isDirty: boolean;
  addButton: boolean;
  onSaveClick: () => void;
  onCancelClick: () => void;
  onEditClick: () => void;
  onAddClick: () => void;
  saving: boolean;
  editDisabled: boolean;
}

export function ActionButtons({
  updatePermission,
  action,
  isDirty,
  addButton,
  onSaveClick,
  onCancelClick,
  onEditClick,
  onAddClick,
  saving,
  editDisabled,
}: ActionButtonsProps) {
  const { t } = useTranslation();

  return (
    <GlobalActions>
      {action === 'view' && updatePermission && (
        <Fab
          color="primary"
          aria-label={t('edit')}
          onClick={onEditClick}
          disabled={editDisabled}
          data-testid="fab-edit"
        >
          <Edit />
        </Fab>
      )}
      {action === 'edit' && (
        <>
          <Fab
            color="primary"
            aria-label={t('Add Service Area')}
            onClick={onAddClick}
            disabled={!addButton || saving}
            data-testid="fab-add"
          >
            <Add />
          </Fab>
          <Fab
            color="primary"
            aria-label={t('Save')}
            onClick={onSaveClick}
            disabled={!isDirty || saving}
            displayDisabled={!saving}
            data-testid="fab-save"
          >
            <Save />
          </Fab>
          <Fab
            color="primary"
            aria-label={t('Cancel')}
            onClick={onCancelClick}
            disabled={saving}
            data-testid="fab-cancel"
          >
            <Cancel />
          </Fab>
          <Fab
            color="inherit"
            label={t('Saving')}
            disabled={!saving}
            data-testid="fab-timelapse"
          >
            <Timelapse />
          </Fab>
        </>
      )}
    </GlobalActions>
  );
}
